<template>
  <vs-tabs>
    <vs-tab :label="$t('Labels.MyData')" icon-pack="feather" icon="icon-user">
      <vx-card>
        <div class="absolute right-0 top-0">
            <vs-button
              @click="editProfile = true"
              v-if="!editProfile"
              class="watersonic edit-button mr-2 mt-2"
              color="primary"
              icon="icon-edit"
              icon-pack="feather"
              type="border"
            />
            <vs-button
              @click="editProfile = false"
              v-if="editProfile"
              class="watersonic edit-button mr-2 mt-2"
              color="primary"
              icon="icon-x"
              icon-pack="feather"
              type="border"
            />
        </div>
        <form v-if="editProfile">
          <div class="vx-row">
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1 text-center">
              <vs-avatar
                size="90px"
                :src="editUser.avatar"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1 text-center">
              <input type="file" id="file" ref="file" @change="handleFileUpload()" class="hidden"/>
              <vs-button class="mt-1"
                @click="$refs.file.click()"
              >
                {{$t("Labels.ChangeImage")}}
              </vs-button>
              <vs-button class="mt-1 ml-1"
                @click="saveImage()"
              >
                {{$t("Labels.Save")}}
              </vs-button>
            </div>
          </div>
          <div class="vx-row">
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1">
              <vs-input
                class="w-full"
                :label="$t('Labels.Name')"
                type="text"
                v-model="editUser.name"
              />
              <span class="text-danger text-sm" v-show="empty(editUser.name)">{{ $t('Messages.Required') }}</span>
            </div>
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1">
              <vs-input
                class="w-full"
                :label="$t('Labels.LastName')"
                type="text"
                v-model="editUser.lastName"
              />
              <span class="text-danger text-sm" v-show="empty(editUser.lastName)">{{ $t('Messages.Required') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1">
              <vs-input
                class="w-full"
                :label="$t('Labels.Phone')"
                type="text"
                v-model="editUser.telephone"
              />
              <span class="text-danger text-sm" v-show="empty(editUser.telephone)">{{ $t('Messages.Required') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="lg:w-1/2 sm:w-1/2 w-full">
            </div>
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1">
              <vs-button class="mt-1 w-full"
                @click="validationForm()"
              >
                {{$t("Labels.Save")}}
              </vs-button>
            </div>
          </div>
        </form>
        <div v-else>
          <div class="lg:w-1/2 sm:w-1/2 w-full px-1 text-center">
            <vs-avatar
              size="90px"
              :src="user.avatar"
            />
            <div>{{user.name}}</div>
            <div>{{user.role}}</div>
          </div>
          <div class="lg:w-1/2 sm:w-1/2 w-full px-1 text-center">
            <valueItem
              :value="user.telephone"
              :description="$t('Labels.Phone')"
              img="phone"
            />
          </div>
        </div>
      </vx-card>
    </vs-tab>
    <vs-tab :label="$t('Labels.ChangePassword')" icon-pack="feather" icon="icon-lock">
      <vx-card>
        <form>
          <div class="vx-row">
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1">
              <vs-input
                class="w-full"
                :label="$t('Labels.OldPassword')"
                type="password"
                v-model="changePassword.oldPassword"
              />
              <span class="text-danger text-sm" v-show="empty(changePassword.oldPassword)">{{ $t('Messages.Required') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1">
              <vs-input
                class="w-full"
                :label="$t('Password')"
                type="password"
                v-model="changePassword.password"
              />
              <span class="text-danger text-sm" v-show="empty(changePassword.password)">{{ $t('Messages.Required') }}</span>
            </div>
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1">
              <vs-input
                class="w-full"
                :label="$t('Labels.ConfirmPassword')"
                type="password"
                v-model="changePassword.confirmPassword"
              />
              <span class="text-danger text-sm" v-show="changePassword.confirmPassword !== changePassword.password">{{ $t('Messages.EqualPassword') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="lg:w-1/2 sm:w-1/2 w-full">
            </div>
            <div class="lg:w-1/2 sm:w-1/2 w-full px-1">
              <vs-button class="mt-2 w-full"
                @click="passwordValidation()"
              >
                {{$t("Labels.Save")}}
              </vs-button>
            </div>
          </div>
        </form>
      </vx-card>
    </vs-tab>
  </vs-tabs>
</template>
<script>
import { request } from '@/request.js'
import { empty } from '@/helpers.js'
import valueItem from '@/components/valueItem/valueItem.vue'

export default {
  components: {
    valueItem
  },
  data () {
    return {
      user: {
        avatar: '',
        name: '',
        role: '',
        telephone: ''
      },
      editUser: {
        avatar: '',
        name: '',
        lastName: '',
        telephone: ''
      },
      response: {},
      changePassword: {
        oldPassword: '',
        password: '',
        confirmPassword: ''
      },
      edit: false,
      infoEdit: {},
      editProfile: false,
      userRole: {
        TA: this.$t('Labels.Admin'),
        TO: this.$t('Labels.Operator')
      },
      file: '',
      empty
    }
  },
  methods: {
    async getProfile () {
      const params = {
        url: 'user/avatar',
        method: 'GET'
      }
      await request(params).then(data => {
        this.user.name = `${data.data.data.first_name  } ${  data.data.data.last_name}`
        this.editUser.name = data.data.data.first_name
        this.editUser.lastName = data.data.data.last_name
        this.user.telephone = data.data.data.phone_number
        this.editUser.telephone = data.data.data.phone_number
        this.user.avatar = `data:image/jpeg;base64,${  data.data.data.avatar}`
        this.editUser.avatar = `data:image/jpeg;base64,${  data.data.data.avatar}`
      })
    },
    async getResponse () {
      const params = {
        url: 'tracker_users',
        method: 'GET'
      }
      await request(params).then(data => {
        this.response = data.data.data
        this.infoEdit.allergies = this.response.allergies
        this.infoEdit.blood_type = this.response.blood_type
        this.infoEdit.chronic_conditions = this.response.chronic_conditions
        this.infoEdit.special_health_indications = this.response.special_health_indications
      })
    },
    async add () {
      const params = {
        url: 'user',
        method: 'PUT',
        params: {
          phone_number: this.editUser.telephone,
          first_name: this.editUser.name,
          last_name: this.editUser.lastName
        }
      }
      await request(params).then(() => {
        this.user.telephone = this.editUser.telephone.toString()
        this.user.name = `${this.editUser.name  } ${  this.editUser.lastName}`
        this.editProfile = false
        this.$store.commit('UPDATE_USER_INFO', {
          displayName: `${this.editUser.name  } ${  this.editUser.lastName}`
        })
      })
    },
    validationForm () {
      if (!empty(this.editUser.name) && !empty(this.editUser.lastName) && !empty(this.editUser.telephone)) {
        this.add()
      }
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      const reader = new FileReader()

      // Leemos el archivo subido y se lo pasamos a nuestro fileReader
      reader.readAsDataURL(this.$refs.file.files[0])

      // Le decimos que cuando este listo ejecute el código interno
      const app = this
      reader.onload = function () {
        app.editUser.avatar = reader.result
      }
    },
    async updatePassword () {
      const params = {
        url: 'user/password',
        method: 'PUT',
        params: {
          oldPass: btoa(this.changePassword.oldPassword),
          newPass: btoa(this.changePassword.password),
          reNewPass: btoa(this.changePassword.confirmPassword)
        }
      }
      await request(params).then(() => {
        this.changePassword = {
          oldPassword: '',
          password: '',
          confirmPassword: ''
        }
      })
    },
    passwordValidation () {
      if (!empty(this.changePassword.password) && !empty(this.changePassword.oldPassword) && !empty(this.changePassword.confirmPassword) && (this.changePassword.confirmPassword === this.changePassword.password)) {
        this.updatePassword()
      }
    },
    async saveImage () {
      const form = new FormData()
      form.append('file', this.file)
      const params = {
        url: 'user/avatar',
        method: 'PUT',
        params: form
      }
      await request(params).then(() => {
        this.user.avatar = this.editUser.avatar.toString()
        localStorage.setItem('avatar', this.editUser.avatar.toString())
      })
    }
  },
  created () {
    this.user.role = this.userRole[this.$store.state.AppActiveUser.userRole]
    this.getProfile()
  }
}
</script>
